import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';

@Component({
  selector: 'ui-date-field',
  standalone: true,
  imports: [CalendarModule, ControlFieldComponent, FormsModule],

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFieldComponent),
      multi: true,
    },
  ],
  templateUrl: './date-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFieldComponent extends PrimeNgControlComponent<Date | null> {}
